import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MessageService} from 'primeng/api';
import {Filter, InfoView, Query} from '../filter.type';
import {FilterSaveListService} from './filter-save-list.service';

const DEFAULT = '[Nouveau Preset]' as const;

interface DefaultSave {
    name: typeof DEFAULT;
}

export interface ClassicSave {
    id: string;
    name: string;
    value: Filter[];
}

type Save = DefaultSave | ClassicSave;


@Component({
    selector: 'dmp-filter-save-list',
    templateUrl: './filter-save-list.component.html',
    styleUrls: ['./filter-save-list.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class FilterSaveListComponent implements OnInit {
    saves: ClassicSave[] = [];
    currentSave: Save = {name: DEFAULT} as Save;
    displayDialog = false;
    name: string;

    @Input() tenant: string;
    @Input() current: Filter[];
    @Input() currentQuery: Query;
    @Output() onLoad = new EventEmitter<ClassicSave>();
    _hash: string;

    constructor(private service: FilterSaveListService) {
    }

    _currentView: InfoView;

    @Input() set currentView(info: InfoView) {
        const hash = JSON.stringify(info);
        if (hash !== this._hash) {
            this._currentView = info;
            this._hash = JSON.stringify(info);
            this.service.loadAll(this._currentView);
        }
    }

    get saveList(): [DefaultSave, ...ClassicSave[]] {
        return [{name: DEFAULT}, ...this.saves];
    }

    ngOnInit(): void {
        this.service.list$.subscribe((el) => this.saves = el.map((el) => ({
            id: el.id,
            name: el.name,
            value: JSON.parse(el.objectQueryJson)
        })));
        this.service.loadAll(this._currentView);
    }

    load() {
        this.onLoad.next(this.currentSave as ClassicSave);
        this.service.load((this.currentSave as ClassicSave).id);
    }

    save() {
        if (this.currentSave.name === DEFAULT) {
            this.displayDialog = true;
        } else {
            this.service.next({...this.currentQuery, json: this.current});
            this.service.update(this.tenant, this.currentSave.name);
        }
    }

    create(name: string) {
        this.service.next({...this.currentQuery, json: this.current});
        this.service.create(name);
    }

    remove() {
        this.service.remove(this.tenant, (this.currentSave as ClassicSave).id);
    }
}
